import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    overflowX: 'auto',
    color: theme.palette.grey[900],
    padding: theme.spacing(1.5, 2),
    fontWeight: theme.typography.fontWeightSemibold,
    borderBottom: `1px solid ${theme.palette.grey[200]}`
  }
}));

export const CrawlerTableHead = ({ children }) => {
  const classes = useStyles();
  return (
    <Grid container className={classes.root}>
      {
        React.Children.map(children, child => {
          const sizeProps = typeof child.props.size === 'object'
            ? child.props.size
            : { xs: 12, sm: parseInt(child.props.size) };
          return (
            <Grid item {...sizeProps}>
              {child}
            </Grid>
          );
        })
      }
    </Grid>
  );
};

CrawlerTableHead.propTypes = {
  children: PropTypes.node.isRequired
};

export default CrawlerTableHead;
